// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1bfmW","selects":"Documents_selects__xRIoO"};